const pendingApprovalForWorkstreamSponsor = ({ initiatives }) => {
  if (!initiatives || !Array.isArray(initiatives)) {
    console.warn('pendingApprovalForWorkstreamLead: initiatives is not a valid array', initiatives);
    return { pending: [], approved: [], notSet: [] };
  }
  const pendingSponsor = [];
  const approvedSponsor = [];
  const notSetSponsor = [];

  initiatives.forEach((initiative) => {
    if (initiative.request && initiative.request.requestedStage) {
      const stage = initiative.stage;
      const requestedStage = initiative.request.requestedStage;
      let approvalStageKey = null;
      if (stage === 'L0' && requestedStage === 'Submitted for L1 Approval') {
        approvalStageKey = 'L1';
      } else if (stage === 'L1' && requestedStage === 'Submitted for L1 Approval') {
        approvalStageKey = 'L1';
      } else if (stage === 'L1' && requestedStage === 'Submitted for L2 Approval') {
        approvalStageKey = 'L2';
      } else if (stage === 'L2' && requestedStage === 'Submitted for L2 Approval') {
        approvalStageKey = 'L2';
      } else if (stage === 'L2' && requestedStage === 'Submitted for L3 Approval') {
        approvalStageKey = 'L3';
      } else if (stage === 'L3' && requestedStage === 'Submitted for L3 Approval') {
        approvalStageKey = 'L3';
      } else if (stage === 'L3' && requestedStage === 'Submitted for L4 Approval') {
        approvalStageKey = 'L4';
      } else if (stage === 'L4' && requestedStage === 'Submitted for L4 Approval') {
        approvalStageKey = 'L4';
      } else if (stage === 'L4' && requestedStage === 'Submitted for L5 Approval') {
        approvalStageKey = 'L5';
      } else if (stage === 'L5' && requestedStage === 'Submitted for L5 Approval') {
        approvalStageKey = 'L5';
      } else {
        // Skip if the stage and requested stage don't match our logic
        return;
      }

      if (initiative.approvalSummary && initiative.approvalSummary[approvalStageKey]) {
        const approvers = initiative.approvalSummary[approvalStageKey].approvers || []; // Ensure approvers is always an array
        if (approvers.length === 1) {
          pendingSponsor.push(initiative);
        } else if (approvers.length >= 2) {
          approvedSponsor.push(initiative);
        }
        else {
          notSetSponsor.push(initiative);
        }
      } else {
        notSetSponsor.push(initiative);
      }
    }
    if (!initiative.request) {
      notSetSponsor.push(initiative);
    }
  });
  return { pendingSponsor, approvedSponsor, notSetSponsor };
};

export default pendingApprovalForWorkstreamSponsor;
